import Cashierreports from "./Cashierreports";
import rp001 from "./rp001"
import rp002 from "./rp002";
import rp003 from "./rp003";
import rp032 from "./rp032";
import rp005 from "./rp005";
import rp006 from "./rp006";
import rp008 from "./rp008";
import rp009 from "./rp009"
import rp028 from "./rp028";
import rp029 from "./rp029";
import rp030 from "./rp030";
import rp015p from "./rp015p";
import rp019 from "./rp019";
import cashbook from "./cashbook";
import rp023 from "./rp023";
import rp025 from "./rp025";
import daybookshift from "./daybookshift";
import rp031 from "./rp031";
import rp010 from "./rp010";

import rp102 from "./rp102";
import rp102l from "./rp102l";

import recovery from "./recovery";

import rp201 from "./rp201";
import rp202 from "./rp202";
import rp203 from "./rp203";
import rp204 from "./rp204";
import rp205 from "./rp205";
import rp240 from "./rp240";
import rp249 from "./rp249";
import rp206 from "./rp206";
import rp207 from "./rp207";
import rp208 from "./rp208";
import rp209 from "./rp209";
import rp210 from "./rp210";
import rp236 from "./rp236";
import receiptandpaymentmonthlysummary from "./receiptandpaymentmonthlysummary"
import receiptandpaymentdaysummary from "./receiptandpaymentdaysummary";
import receiptandpaymentdaysummaryandanotherperiod from "./receiptandpaymentdaysummaryandanotherperiod";
import accountriskreport from "./accountriskreport";
import rp226 from "./rp226";
import tdsregisterbranchsummary from "./tdsregisterbranchsummary";
import atmlogregister from "./atmlogregister";
import dormantacstransactions from "./dormantacstransactions"



// import rp010 from "./rp010";
// import rp010 from "./rp010";
// import rp010 from "./rp010";
// import rp010 from "./rp010";
// import rp010 from "./rp010";


import rp444 from "./rp444";
import rp2131 from "./rp2131";
import rp2132 from "./rp2132";
import rp2133 from "./rp2133";
import rp2134 from "./rp2134";
import rprbi1 from "./rprbi1";
import rprbi2 from "./rprbi2";
import rprbi3 from "./rprbi3";
import rprbi4 from "./rprbi4";
import rprbi5 from "./rprbi5";
import rprbi6 from "./rprbi6";
import rp1031 from "./rp1031";
import rprbi8 from "./rprbi8";
import rprbi7 from "./rprbi7";
import rprbi9 from "./rprbi9";
import rprbi10 from "./rprbi10";
import rprbi11 from "./rprbi11";
import rprbi13 from "./rprbi13";
import rprbi12 from "./rprbi12";
import rprbi16 from "./rprbi16";
import rprbi17 from "./rprbi17";
import rprbi14 from "./rprbi14";
import rprbi18 from "./rprbi18";
import rprbi19 from "./rprbi19";
import rprbi22 from "./rprbi22";
import rprbi23 from "./rprbi23";
import rprbi24 from "./rprbi24";
import rprbi25 from "./rprbi25";
import rprbi26 from "./rprbi26";
import rprbi27 from "./rprbi27";
import rprbi30 from "./rprbi30";
import rprbi33 from "./rprbi33";
import rprbi15 from "./rprbi15";
import rprbi31 from "./rprbi31";
import rprbi29 from "./rprbi29";
import rprbi28 from "./rprbi28";
import rprbi20 from "./rprbi20";
import rprbi21 from "./rprbi21";
import rprbi32 from "./rprbi32";
import suspecioustxn from "./suspecioustxn";
import rp101m from "./rp101m";
import rp101o from "./rp101o";
import apexpendency from "./apexpendency";
import bankapexpendency from "./bankapexpendency";
import apexpendencydcc from "./apexpendencydcc";
import rpc1 from "./rpc1";
import pacs_financial_position from "./pacs_financial_position";
import pacs_financial_position_bank from "./pacs_financial_position_bank";
import pacs_ots_position from "./pacs_ots_position";
import pacs_ots_bank from "./pacs_ots_bank";
import rpad1 from "./rpad1";
import rpad11 from "./rpad11";
import rpad2 from "./rpad2";
import rpad3 from "./rpad3";
import rpad15 from "./rpad15";
import rpad13 from "./rpad13";
import rpad22 from "./rpad22";
import rpad24 from "./rpad24";
import rpad33 from "./rpad33";
import rpad35 from "./rpad35";
import rpad4 from "./rpad4";
import rpad16 from "./rpad16";
import rpad37 from "./rpad37";
import rpad7 from "./rpad7";
import rpad8 from "./rpad8";
import rpad17 from "./rpad17";
import rpad18 from "./rpad18";
import rpad19 from "./rpad19";
import rpad181 from "./rpad181";
import rpcf1 from "./rpcf1";
import rpcf2 from "./rpcf2";
import rpcf11 from "./rpcf11";
import rpcf12 from "./rpcf12";
import rpcf13 from "./rpcf13";
import rpcf22 from "./rpcf22";
import rpcf23 from "./rpcf23";
import rpad191 from "./rpad191";
import rpad182 from "./rpad182";
import rpcf3 from "./rpcf3";
import rpcf4 from "./rpcf4";
import rpcf5 from "./rpcf5";
import rpcf6 from "./rpcf6";
import rpcf7 from "./rpcf7";
import rpcf24 from "./rpcf24";
import rpcf30 from "./rpcf30";
import rpcf25 from "./rpcf25";
import rpcf2x from "./rpcf2x";
import rpnf1 from "./rpnf1";
import rpnf2 from "./rpnf2";
import rpad192 from "./rpad192";
import rpad193 from "./rpad193";
import rpad131 from "./rpad131";
import rpad132 from "./rpad132";
import recomplliancedcc from "./recomplliancedcc";
import rpad14 from "./rpad14";
import dashmenu from "./dashmenu";
import rpdr1 from "./rpdr1";
import account_balancing from "./account_balancing";
import gl_statements from "./gl_statements";
import trial_balance from "./trial_balance";
import cashier_scroll from "./cashier_scroll";
import branches_subdaybook from "./branches_subdaybook";
import loan_account_opening_register from "./loan_account_opening_register";
import pmsby_register from "./pmsby_register";
import pmjjby_register from "./pmjjby_register";
import lien_register from "./lien_register";
import account_chequebook_register from "./account_chequebook_register";
import as from "./as";
import rpdr21 from "./rpdr21";
import rpdr22 from "./rpdr22";
import rpcf50 from "./rpcf50";
import rpdrp1 from "./rpdrp1";
import rpdrp2 from "./rpdrp2";
import rpdrp3 from "./rpdrp3";
import atm_sms1 from "./atm_sms1";
import atm_sms_2 from "./atm_sms_2";
import suspicious_transactions from "./suspicious_transactions";
import suspicious_trn_ac from "./suspicious_trn_ac";
import suspicious_trn_taluka from "./suspicious_trn_taluka";
import atm_issue_rp1 from "./atm_issue_rp1";
import atm_issue_rp2 from "./atm_issue_rp2";
import suspicious_tran_talathi from "./suspicious_tran_talathi";
import rpad133 from "./rpad133";
import rpsl1 from "./rpsl1";
import rpdr41 from "./rpdr41";
import rpsl2 from "./rpsl2";
import rpsl3 from "./rpsl3";
import rpsl4 from "./rpsl4";
import rpsl5 from "./rpsl5";

import bwu from "./bwu";
import bwul from "./bwul";
import todays_branch_suggestions from "./todays_branch_suggestions";
import branch_suggestion_status from "./branch_suggestion_status";
import rpdr4 from "./rpdr4";
import rpdr5 from "./rpdr5";
import myticket from "./myticket";
import newissue from "./newissue";
import assignedIssues from "./assignedIssues";
import ongoingIssues from "./ongoingIssues";
import teamstatistics from "./teamstatistics";
import myIssues from "./myIssues";
import gstr1 from "./gstr1";
import rpsl25 from "./rpsl25";
import rpsl6 from "./rpsl6";
import rpsl7 from "./rpsl7";
import rpsl8 from "./rpsl8";
import rpsl9 from "./rpsl9";
import rpsl10 from "./rpsl10";
import rpsl11 from "./rpsl11";
import rpsl12 from "./rpsl12";
import rpsl13 from "./rpsl13";
import rpsl14 from "./rpsl14";
import rpsl15 from "./rpsl15";
import rpsl16 from "./rpsl16";
import rpsl17 from "./rpsl17";
import rpsl18 from "./rpsl18";
import rpsl19 from "./rpsl19";
import rpsl20 from "./rpsl20";
import rpsl21 from "./rpsl21";
import rpsl22 from "./rpsl22";
import rpsl23 from "./rpsl23";
import rpsl24 from "./rpsl24";
import rpsl26 from "./rpsl26";
import rpsl27 from "./rpsl27";
import rpsl28 from "./rpsl28";
import rpsl29 from "./rpsl29";
import slbcstatus from "./slbcstatus";
import rpapb1l from "./rpapb1l";
import rpcf8 from "./rpcf8";
import device_live_status from "./device_live_status";
import late_comers from "./late_comers";
import pcmc_employee_attendance_status from "./pcmc_employee_attendance_status";
import pcmc_employee_attendance from "./pcmc_employee_attendance";
import attendance_status from "./attendance_status";
import pcmcsalaryslips from "./pcmcsalaryslips";
import department_wise_payments from "./department_wise_payments";
import department_bill from "./department_bill";
import pcmc_employee_sal_stru from "./pcmc_employee_sal_stru";
import department_bill_of_month from "./department_bill_of_month";
import dept_bill from "./dept_bill";
import dept_emp_bill from "./dept_emp_bill";
import attconsol from "./attconsol";
import tgc1 from "./tgc1";
import tgc2 from "./tgc2";
import age_wise_count from "./age_wise_count";
import married_child_count from "./married_child_count";
import child_marriges_count from "./child_marriges_count";
import tgc_consolidated from "./tgc_consolidated";
import girl_child_count from "./girl_child_count";
import talukas_data_entry_status from "./talukas_data_entry_status";
import montly_in_out_attendnace from "./montly_in_out_attendnace";
import salary_dedications from "./salary_dedications";
import tgc_list from "./tgc_list";
import matching_records from "./matching_records";
import matching_records_bar from "./matching_records_bar";
import tgc_talukas_matching from "./tgc_talukas_matching";
//import matchings from "./matchings";
import vwspd from "./vwspd";
import enreport from "./enreport";
import matchingstat from "./matchingstat";
import tgc_taluka_bar from "./tgc_taluka_bar";
import tgc_taluka_match from "./tgc_taluka_match";
import beo_mon_rp1 from "./beo_mon_rp1";
import beo from "./beo";
import beo_mon_rp2 from "./beo_mon_rp2";
import col_mon_rp2 from "./col_mon_rp2";
import col_mon_rp4 from "./col_mon_rp4";
import rp5 from "./rp5";
import rp6 from "./rp6";
import rp7 from "./rp7";
import rp8 from "./rp8";
import rp9 from "./rp9";
import rp10 from "./rp10";
import beo_progress_bar from "./beo_progress_bar";
import rptgc1 from "./rptgc1";
import rptgc2 from "./rptgc2";
import rp11 from "./rp11";
import rp12 from "./rp12";
import rpttgccol1 from "./rpttgccol1";
import am1 from "./am1";
export default {
  am1,
  rpttgccol1,
  rp12,
  rp11,
  rptgc2,
  rptgc1,
  beo_progress_bar,
  rp10,
  rp9,
  rp8,
  rp7,
  rp6,
  rp5,
  col_mon_rp4,
  col_mon_rp2,
  beo_mon_rp2,
  beo,
  beo_mon_rp1,
  tgc_taluka_match,
  tgc_taluka_bar,
  matchingstat,
  enreport,
  vwspd,
  //matchings,
  tgc_talukas_matching,
  matching_records_bar,
  matching_records,
  tgc_list,
  salary_dedications,
  montly_in_out_attendnace,
  talukas_data_entry_status,
  girl_child_count,
  tgc_consolidated,
  child_marriges_count,
  married_child_count,
  age_wise_count,
  tgc2,
  tgc1,
  attconsol,
  dept_emp_bill,
  dept_bill,
  department_bill_of_month,
  pcmc_employee_sal_stru,
  department_bill,
  department_wise_payments,
  pcmcsalaryslips,
  attendance_status,
  pcmc_employee_attendance,
  pcmc_employee_attendance_status,
  late_comers,
  device_live_status,
  rpcf8,
  rpapb1l,
  slbcstatus,
  rpsl29,
  rpsl28,
  rpsl27,
  rpsl26,
  rpsl24,
  rpsl23,
  rpsl22,
  rpsl21,
  rpsl20,
  rpsl19,
  rpsl18,
  rpsl17,
  rpsl16,
  rpsl15,
  rpsl14,
  rpsl13,
  rpsl12,
  rpsl11,
  rpsl10,
  rpsl9,
  rpsl8,
  rpsl7,
  rpsl6,
  rpsl25,
  gstr1,
  myIssues,
  teamstatistics,
  ongoingIssues,
  assignedIssues,
  newissue,
  myticket,
  rpdr5,
  rpdr4,
  branch_suggestion_status,
  todays_branch_suggestions,
  bwul,
  bwu,
  rpsl5,
  rpsl4,
  rpsl3,
  rpsl2,
  rpdr41,
  rpsl1,
  rpad133,
  suspicious_tran_talathi,
  atm_issue_rp2,
  atm_issue_rp1,
  suspicious_trn_taluka,
  suspicious_trn_ac,
  suspicious_transactions,
  atm_sms_2,
  atm_sms1,
  rpdrp3,
  rpdrp2,
  rpdrp1,
  rpcf50,
  rpdr22,
  rpdr21,
  as,
  account_chequebook_register,
  lien_register,
  pmjjby_register,
  pmsby_register,
  loan_account_opening_register,
  branches_subdaybook,
  cashier_scroll,
  trial_balance,
  gl_statements,
  account_balancing,
  rpdr1,
  dashmenu,
  rpad14,
  recomplliancedcc,
  rpad132,
  rpad131,
  rpad193,
  rpad192,
  rpnf2,
  rpnf1,
  rpcf2x,
  rpcf25,
  rpcf30,
  rpcf24,
  rpcf7,
  rpcf6,
  rpcf5,
  rpcf4,
  rpcf3,
  rpad182,
  rpad191,
  rpcf23,
  rpcf22,
  rpcf13,
  rpcf12,
  rpcf11,
  rpcf2,
  rpcf1,
  rpad181,
  rpad19,
  rpad18,
  rpad17,
  rpad8,
  rpad7,
  rpad37,
  rpad16,
  rpad4,
  rpad35,
  rpad33,
  rpad24,
  rpad22,
  rpad13,
  rpad15,
  rpad3,
  rpad2,
  rpad11,
  rpad1,
  pacs_ots_bank,
  pacs_ots_position,
  pacs_financial_position_bank,
  pacs_financial_position,
  rpc1,
  apexpendencydcc,
  bankapexpendency,
  apexpendency,
  rp101o,
  rp101m,
  suspecioustxn,
  rprbi32,
  rprbi21,
  rprbi20,
  rprbi28,
  rprbi29,
  rprbi31,
  rprbi15,
  rprbi33,
  rprbi30,
  rprbi27,
  rprbi26,
  rprbi25,
  rprbi24,
  rprbi23,
  rprbi22,
  rprbi19,
  rprbi18,
  rprbi14,
  rprbi17,
  rprbi16,
  rprbi12,
  rprbi13,
  rprbi11,
  rprbi10,
  rprbi9,
  rprbi7,
  rprbi8,
  rp1031,
  rprbi6,

  rprbi5,

  rprbi4,

  rprbi3,

  rprbi2,

  rprbi1,
  rp2134,

  rp201,
  rp202,
  rp203,
  rp204,
  rp205,
  rp240,
  rp249,
  rp206,
  rp207,
  rp208,
  rp209,
  rp210,
  rp236,
  receiptandpaymentmonthlysummary,
  receiptandpaymentdaysummary,
  receiptandpaymentdaysummaryandanotherperiod,
  accountriskreport,
  rp226,
  tdsregisterbranchsummary,
  atmlogregister,
  dormantacstransactions,
  recovery,

  rp2133,
  rp2132,
  rp2131,


  rp444,

  ...Cashierreports,
  rp001,
  rp002,
  rp003,
  rp032,
  rp005,
  rp006,
  rp008,
  rp009,
  rp028,
  rp029,
  rp030,
  rp015p,
  rp019,
  cashbook,
  rp023,
  rp025,
  daybookshift,
  rp031,
  rp010,

  rp102,
  rp102l
}
